import {
  ICookieDeclaration,
  TCookieCategory
} from '@shared/interfaces/cookie-consent.interface';

export const COOKIE_REGISTRY: ICookieDeclaration[] = [
  // --- Strictly necessary (always active, not consent-gated) ---
  {
    name: 'vitay_cookie_consent',
    provider: 'Vitay',
    category: 'necessary',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.CONSENT_STORAGE',
    duration: '12 months',
    type: 'cookie'
  },
  {
    name: 'recruiter-token',
    provider: 'Vitay',
    category: 'necessary',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.AUTH_TOKEN',
    duration: '15 days',
    type: 'cookie'
  },
  {
    name: 'candidate-token',
    provider: 'Vitay',
    category: 'necessary',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.AUTH_TOKEN',
    duration: '15 days',
    type: 'cookie'
  },
  {
    name: 'mfa',
    provider: 'Vitay',
    category: 'necessary',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.MFA',
    duration: '15 days',
    type: 'cookie'
  },
  {
    name: '_vitay_session',
    provider: 'Vitay',
    category: 'necessary',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.API_SESSION',
    duration: 'Session',
    type: 'cookie'
  },
  {
    name: 'stytch_session',
    provider: 'Stytch',
    category: 'necessary',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.SSO_SESSION',
    duration: '24 hours',
    type: 'cookie'
  },
  {
    name: 'stytch_session_jwt',
    provider: 'Stytch',
    category: 'necessary',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.SSO_SESSION',
    duration: '24 hours',
    type: 'cookie'
  },
  {
    name: 'lng',
    provider: 'Vitay',
    category: 'necessary',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.LANGUAGE',
    duration: 'Persistent',
    type: 'localStorage'
  },
  {
    name: 'hiringFirm',
    provider: 'Vitay',
    category: 'necessary',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.WHITE_LABEL',
    duration: 'Session',
    type: 'sessionStorage'
  },
  {
    name: '__stripe_mid',
    provider: 'Stripe',
    category: 'necessary',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.STRIPE_FRAUD',
    duration: '12 months',
    type: 'cookie'
  },
  {
    name: '__stripe_sid',
    provider: 'Stripe',
    category: 'necessary',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.STRIPE_FRAUD',
    duration: '30 minutes',
    type: 'cookie'
  },
  {
    name: '__cf_bm',
    provider: 'Cloudflare',
    category: 'necessary',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.BOT_PROTECTION',
    duration: '30 minutes',
    type: 'cookie'
  },
  {
    name: '_cfuvid',
    provider: 'Cloudflare',
    category: 'necessary',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.BOT_PROTECTION',
    duration: 'Session',
    type: 'cookie'
  },
  // --- Functional ---
  {
    name: 'hs-beacon-*',
    provider: 'Help Scout',
    category: 'functional',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.HELPSCOUT',
    duration: 'Persistent',
    type: 'localStorage'
  },
  // --- Analytics ---
  {
    name: '_ga',
    provider: 'Google Analytics',
    category: 'analytics',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.GA',
    duration: '13 months',
    type: 'cookie'
  },
  {
    name: '_ga_*',
    provider: 'Google Analytics',
    category: 'analytics',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.GA_SESSION',
    duration: '13 months',
    type: 'cookie'
  },
  {
    name: '_gid',
    provider: 'Google Analytics',
    category: 'analytics',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.GA',
    duration: '24 hours',
    type: 'cookie'
  },
  {
    name: '_hjSessionUser_*',
    provider: 'Hotjar',
    category: 'analytics',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.HOTJAR',
    duration: '12 months',
    type: 'cookie'
  },
  {
    name: '_hjSession_*',
    provider: 'Hotjar',
    category: 'analytics',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.HOTJAR',
    duration: '30 minutes',
    type: 'cookie'
  },
  // --- Advertisement ---
  {
    name: '_fbp',
    provider: 'Meta (Facebook Pixel)',
    category: 'advertisement',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.FACEBOOK',
    duration: '3 months',
    type: 'cookie'
  },
  {
    name: 'li_gc',
    provider: 'LinkedIn',
    category: 'advertisement',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.LINKEDIN',
    duration: '6 months',
    type: 'cookie'
  },
  {
    name: 'bcookie',
    provider: 'LinkedIn',
    category: 'advertisement',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.LINKEDIN',
    duration: '12 months',
    type: 'cookie'
  },
  {
    name: 'UserMatchHistory',
    provider: 'LinkedIn',
    category: 'advertisement',
    purposeKey: 'COOKIE_CONSENT.PURPOSES.LINKEDIN',
    duration: '30 days',
    type: 'cookie'
  }
];

export const cookiesForCategory = (
  category: TCookieCategory
): ICookieDeclaration[] =>
  COOKIE_REGISTRY.filter((c: ICookieDeclaration) => c.category === category);
